var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Evaluacion',{attrs:{"receivedValue":_vm.evaluationValueReceived,"flagEvalGroup":true,"levels":_vm.lists.levels},on:{"listenChild":_vm.evaluationValueChild,"listenLevel":_vm.evaluationLevelChild}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }